import React, { Component } from "react";
import {Card,
Button,
CardTitle,
CardText,
CardLink,
Col,
FormGroup,
InputGroup,
InputGroupAddon,
Alert,
Input
} from "reactstrap";




import {MdLock} from "react-icons/md"
import {FaUser} from "react-icons/fa";

class Register extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      password2: "",
      
      errors: {}
    };
  }
// onChange = e => {
//     this.setState({ [e.target.id]: e.target.value });
//   };

  handleRegister = e => {
    e.preventDefault();
const newUser = {
      username:this.state.username,
      password: this.state.password,
      password2: this.state.password2
    };

    fetch('http://10.0.30.44:7378/registerUser', {
        method: 'post',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newUser)
    }).then(res => console.log(res)
    ).then(err => {
        console.log(err)
    });
  };


render() {
    const { errors } = this.state;
    let errorMessages = this.props.parentState.errorMessages;
return (
    <div
    className="col-sm-4 offset-sm-4"
    style={{ textAlign: "center", marginTop: 200 }}
  >
            {/* <Link to="/" className="btn-flat waves-effect">
              <i className="material-icons left">keyboard_backspace</i> Back to
              home
            </Link> */}
            {/* <div className="col s12" style={{ paddingLeft: "11.250px" }}>
              <h4>
                <b>Register</b> below
              </h4>
              <p className="grey-text text-darken-1">
                Already have an account? <Link to="/login">Log in</Link>
              </p>
            </div> */}
            <div className="col-sm-12 row">
        <div className="col-sm-4"  > <img  width="80" src="/images/oro-logo1.png" /></div>
        <div className="col-sm-6" style={{fontStyle:"italic",fontWeight:"bold",fontSize:"25px",marginTop:"20px", marginLeft: "-80px",}}>Register</div>
        </div>

<Card
            body
            className="card text-black bg-light sm-3"
            style={{ height: "20rem" }}
          >
           
             
            <FormGroup row>
              <Col sm={{ size: 10, offset: 1 }}>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                     <FaUser /> 
                    </span>
                  </div>
                  <Input 
                    placeholder="username"
                    name="username"
                    onChange={e => this.setState({ username: e.target.value })}
                    
                    type="text"
                    autoFocus='true'
                    refs="username"
                    onKeyDown={this.onkeyPressDown}
                   // onKeyPress={(event) => this.handleKeyPress('password', event)}
                  />
                </div>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Col sm={{ size: 10, offset: 1 }}>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                     <MdLock /> 
                    </span>
                  </div>
                  <Input 
                    placeholder="password"
                    name="password"
                    
                    onChange={e => this.setState({ password: e.target.value })}
                    error={errors.password}
                    type="password"
                    refs="password"
                   onKeyDown={this.onkeyPressDown}
                  
                  />
                </div>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 10, offset: 1 }}>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                     <MdLock /> 
                    </span>
                  </div>
                  <Input 
                    placeholder="confirm password"
                    name="password2"
                    
                    onChange={e => this.setState({ password2: e.target.value })}
                    error={errors.password2}
                    type="password"
                    refs="password2"
                   onKeyDown={this.onkeyPressDown}
                  
                  />
                </div>
              </Col>
            </FormGroup>

            <div>
              <Col sm={{ size: 10, offset: 1 }}>
                <Button
                  className="btn  text-black btn-outline-primary btn-primary btn-md "
                  style={{ width: "100px", textAlign: "center", marginTop: 20 }}
                  onClick={this.handleRegister}
                >
                  Sign Up
                </Button>
              </Col>
      
              {errorMessages && errorMessages["Register"] ? (
                <Alert
                  className="alert alert-danger"
                  style={{
                    marginTop: "5px",
                    marginBottom: "0px",
                    padding: "7px 20px",
                    color: "danger"
                  }}
                >
                  {errorMessages["Register"]}
                </Alert>
              ) : (
                ""
              )}
            </div>      
          </Card>
            
          
      </div>
    );
  }
}
export default Register